import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Button } from 'govuk-react-jsx';
import { useSelector } from 'react-redux';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import useTitle from '../../hooks/useTitle';

const CannotProceed = () => {
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;
  const history = useHistory();
  useTitle(
    'landlordReg.CannotProceed.s8',
    'You cannot apply without a company registration or VAT number - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );
  const handleBtnClick = () => {
    history.push('/signin');
  };

  return (
    <>
      <h1 className="govuk-heading-xl">
        {copyProvider.getCopy(
          'landlordReg.CannotProceed.s1',
          'You cannot proceed'
        )}
      </h1>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'landlordReg.CannotProceed.s2',
          'To create an account and apply for this grant you must be able to prove you are a UK registered business.'
        )}
      </p>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'landlordReg.CannotProceed.s3',
          'You can identify your business by providing either:'
        )}
      </p>

      <p className="govuk-body">
        <ul className="govuk-list--bullet">
          <li className="govuk-list--bullet">
            <Link
              className="govuk-link govuk-body govuk-!-font-size-19"
              to="/landlordReg/company-registration-number"
            >
              {copyProvider.getCopy(
                'landlordReg.CannotProceed.s4',
                'Company registration number:'
              )}
            </Link>
            {copyProvider.getCopy('landlordReg.CannotProceed.s5', ' or')}
          </li>
          <li className="govuk-list--bullet">
            <Link
              to="/landlordReg/company-VAT-number"
              className="govuk-link govuk-body govuk-!-font-size-19"
            >
              {copyProvider.getCopy(
                'landlordReg.CannotProceed.s6',
                'UK VAT registration number'
              )}
            </Link>
          </li>
        </ul>
      </p>
      <Button
        className="govuk-button-group govuk-!-margin-top-7"
        onClick={handleBtnClick}
      >
        {copyProvider.getCopy(
          'landlordReg.CannotProceed.s7',
          'Cancel my account registration'
        )}
      </Button>
    </>
  );
};

export default CannotProceed;
